module.exports = __webpack_public_path__ + "static/img/title-banner1-type2.1cf8b51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/7/title-banner1-type2.png
// module id = UCbZ
// module chunks = 1